import { Component, Prop, h, Host } from '@stencil/core';
import { addClass } from '../../utils/helpers/helpers';

@Component({
  tag: 'lgr-select-option-group',
  styleUrl: 'selectOptionGroup.scss',
  shadow: true,
})
export class SelectOptionGroup {
  /**
   * The label text for the option group.
   */
  @Prop({ reflect: true }) label!: string;

  render() {
    return (
      <Host role="group" aria-role="group">
        {this.label && <li class={addClass(['suboption-label'])}>{this.label}</li>}
        <slot></slot>
      </Host>
    );
  }
}
